import { IDoctor } from "@interfaces";
import React from "react";
import { DoctorForm } from "../doctor";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";

interface ModalFormProps {
  open: boolean;
  onCancel: () => void;
  doctor?: IDoctor;
  callback: (values: IDoctor) => void;
  update: (values: IDoctor) => void;
}

export const ModalForm: React.FC<ModalFormProps> = ({
  open,
  onCancel,
  doctor,
  callback,
  update,
}) => {
  const { t } = useTranslation();
  return (
    <Modal title={t("page.add_provider")} open={open} onCancel={onCancel} footer={null} width={700}>
      <DoctorForm callback={callback} doctor={doctor} update={update} cancel={onCancel} />
    </Modal>
  );
};
